var ajaxRootUri = "";
var ajaxTargetPid = 0;

angular.module('IndicatorStructure').factory('DataService', [
  '$http',
  '$q',
  function ($http, $q) {
    'use strict';
    return {
      list: function (data) {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'Indicator',
              'actionName': 'listModelJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      copyToCommune: function (indicator, category, isSet) {
        var deferred = $q.defer();
        var paramms = {
          'id': ajaxTargetPid,
          'extensionName': 'Itaohyperion',
          'pluginName': 'Pi102',
          'controllerName': 'Indicator',
          'actionName': 'copyModelToCommune',
          'arguments[indicator]': JSON.stringify(indicator),
          'arguments[category]': JSON.stringify(category)
        };
        if (isSet) {
          paramms.actionName = 'copyTypeToCommune';
        }
        $http
          .get(ajaxRootUri, {
            params: paramms
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      categoryTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorCategory',
              'actionName': 'getCategoryTreeJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      fullTree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'IndicatorCategory',
              'actionName': 'getFullTreeJson'
            }
          }).success(function (data) {
            deferred.resolve(data);
          }
        ).error(deferred.reject);

        return deferred.promise;
      },
      tree: function () {
        var deferred = $q.defer();
        $http
          .get(ajaxRootUri, {
            params: {
              'id': ajaxTargetPid,
              'extensionName': 'Itaohyperion',
              'pluginName': 'Pi102',
              'controllerName': 'Indicator',
              'actionName': 'getAtlasTreeList',
              'arguments': {
                'dataLayer': 11,
                'published': 0,
                'commune': 14
              }
            }
          })
          .success(
            function (data) {

            }
          ).error(deferred.reject);

        return deferred.promise;
      }
    };
  }
]);
